'use client';

import { createContext, type PropsWithChildren, useMemo, useState } from 'react';
import type { ItemUI } from '@libs/common-node';

export type AutoshipConfirmProps = Record<string, unknown>;

export interface AutoshipConfirmContextProps {
    autoshipConfirmItem?: ItemUI | null;
    setAutoshipConfirmItem: (item: ItemUI | null | undefined) => void;
    confirmRecurringOrder?: string | null;
    setConfirmRecurringOrderDate: (placeDate: string | null | undefined) => void;
}

export const AutoshipConfirmContext = createContext<AutoshipConfirmContextProps | null>(null);

export function AutoshipConfirmProvider({ children }: PropsWithChildren<AutoshipConfirmProps | null>) {
    const [autoshipConfirmItem, setAutoshipConfirmItem] = useState<ItemUI | null>();
    const [confirmRecurringOrder, setConfirmRecurringOrderDate] = useState<string | null>();

    const value = useMemo(
        () => ({
            autoshipConfirmItem,
            setAutoshipConfirmItem,
            confirmRecurringOrder,
            setConfirmRecurringOrderDate,
        }),
        [autoshipConfirmItem, confirmRecurringOrder]
    );

    return <AutoshipConfirmContext.Provider value={value}>{children}</AutoshipConfirmContext.Provider>;
}
